/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021, 2025
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/
import isExternal from 'is-url-external';

/*
 * Returns the href string to use for a react-router RLink, or null
 * if the RLink should be omitted causing next-link/Link to render as plain Carbon
 */
export function getReactHref(href: string): string | null {
  // eslint-disable-next-line no-script-url
  if (!href || href === '#' || href.indexOf('javascript:') === 0) {
    return null;
  }
  if (!href.startsWith('http')) {
    return href;
  }
  // for href starting with http, return null if link is external, or
  //  if internal strip protocol and server to make a relative url
  if (isExternal(href)) {
    return null;
  }

  // Assisted by watsonx Code Assistant
  // We retrieve the base URI of the page and extract its path element.
  // This works consistently across our different environments:
  // - in WXA stand-alone, the base URI path name is simply "/"
  // - in WXA CPD stand-alone, the base URI path name is "/assistant/cpd-wa/"
  // - in WXO SaaS (IBM Cloud or AWS), the base URI path name is "/assistants"
  // - in WXO CPD, the base URI path name is  "/orchestrate/assistants"
  const url = new URL(document.baseURI);
  const baseUriPathname = url.pathname;

  const pubPath = baseUriPathname.endsWith('/')
    ? baseUriPathname
    : `${baseUriPathname}/` || '/';

  let retVal = href.substring(8); //strip leading http:// or https://
  const relativeStart = retVal.indexOf(pubPath) + pubPath.length - 1;
  retVal = retVal.substring(relativeStart);
  return retVal;
}
